import { Component, Input, OnInit } from '@angular/core';
import { AmountUtils } from '../../../../../services/utils/format-amounts.utils';
import { OffcanvasHistoryService } from '../../../../../services/offcanvas-history.service';
import { Profile } from '../../../../models/profile.model';
import { WalletOffcanvasComponent } from '../../../../web/components/wallet-offcanvas/wallet-offcanvas.component';
import { Wallet } from '../../../../models/wallet.model';
import { AccountService } from '../../../../auth/services/account.service';

@Component({
  selector: 'app-wallet-tool',
  templateUrl: './wallet-tool.component.html',
  styleUrls: ['./wallet-tool.component.css'],
  standalone: false
})
export class WalletToolComponent implements OnInit {
  @Input() profile?: Profile;
  @Input() wallet?: Wallet;
  AmountUtils = AmountUtils;
  isAmountHidden = false;

  constructor(private offcanvasHistory: OffcanvasHistoryService,
    private accountService: AccountService
  ) { }

  async ngOnInit() {
    if (this.profile) {
      this.isAmountHidden = this.profile?.partner?.hideWalletAmount ?? false;
    }
  }

  toggleAmountVisibility(event: Event) {
    try {
      event.stopPropagation();
      this.isAmountHidden = !this.isAmountHidden;
      this.accountService.toggleWalletVisibility();
    } catch (error) {
      console.error('Error toggling wallet visibility:', error);
    }
  }

  getAmountClass(): string {
    return AmountUtils.usageClass(this.wallet?.unpaidTotal, this.wallet?.threshold);
  }

  onClick() {
    const offcanvasRef = this.offcanvasHistory.open(WalletOffcanvasComponent, {
      position: 'end',
      scroll: false,
      backdrop: true,
      class: 'app-fixed-width-offcanvas'
    });

    offcanvasRef.componentInstance.profile = this.profile;
    offcanvasRef.componentInstance.wallet = this.wallet;
    offcanvasRef.result.then(() => {
      document.body.style.overflow = 'hidden';
    });
  }
}